import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IDebitsState } from './debits.state';

export class DebitsSelectors {
  static readonly debitsState = (state: IRootState): IDebitsState => {
    return state.debits as IDebitsState;
  };

  static readonly model = createSelector(DebitsSelectors.debitsState, (debits: IDebitsState) => {
    return debits.model;
  });

  static readonly data = createSelector(DebitsSelectors.debitsState, (debits: IDebitsState) => {
    return debits.data;
  });
}
